import { getSubsetAndItemParams } from './getSubsetAndItemParams';

type RowExpandTarget = {
  kind: 'subset' | 'detail';
  subsetId?: string;
};

// Decides which tab a freshly expanded row should open: URL is the source of
// truth; slaveTabIndex is only a fallback for reopening a fully-closed row.
export const resolveRowExpandTarget = (
  pathname: string,
  slaveTabIndex: number,
  subsets: { datasetId: string }[] | undefined,
  detailEnabled: boolean = true
): RowExpandTarget => {
  const { subsetId, itemId } = getSubsetAndItemParams(pathname);

  if (subsetId) return { kind: 'subset', subsetId };

  if (itemId === undefined && slaveTabIndex > 0) {
    const activeSubsetId = subsets?.[slaveTabIndex - 1]?.datasetId;
    if (activeSubsetId) return { kind: 'subset', subsetId: activeSubsetId };
  }

  // Detail tab hidden: the remembered subset stands in for it, else the first one.
  if (!detailEnabled) {
    const fallbackIndex = slaveTabIndex > 0 ? slaveTabIndex : 1;
    const fallbackSubsetId = subsets?.[fallbackIndex - 1]?.datasetId;
    if (fallbackSubsetId) return { kind: 'subset', subsetId: fallbackSubsetId };
  }

  return { kind: 'detail' };
};
